module.exports = __webpack_public_path__ + "static/img/11.efcb4b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/11.png
// module id = lbOy
// module chunks = 0